import { CFTokens } from '../../../tokens';
export const SEGMENT_CONTROL_BADGE_SIZE = {
    xs: 'sm',
    sm: 'md',
    md: 'md',
    lg: 'md',
    xl: 'lg',
};
export const SEGMENT_CONTROL_LABEL_COLOR = {
    alternate: {
        DEFAULT: CFTokens.COLOR.TEXT_AND_ELEMENT_ALTERNATE_DEFAULT,
        SELECTED: CFTokens.COLOR.TEXT_AND_ELEMENT_DEFAULT,
    },
    strong: {
        DEFAULT: CFTokens.COLOR.TEXT_AND_ELEMENT_DEFAULT,
        SELECTED: CFTokens.COLOR.TEXT_AND_ELEMENT_ACCENT,
    },
    subtle: {
        DEFAULT: CFTokens.COLOR.TEXT_AND_ELEMENT_DEFAULT,
        SELECTED: CFTokens.COLOR.TEXT_AND_ELEMENT_BRAND,
    },
};
export const SEGMENT_CONTROL_PADDING_HORIZONTAL = {
    xs: CFTokens.SPACER.C,
    sm: 14,
    md: CFTokens.SPACER.D,
    lg: 20,
    xl: CFTokens.SPACER.E,
};
export const SEGMENT_CONTROL_PADDING_HORIZONTAL_WITH_BADGE = {
    xs: CFTokens.SPACER.A,
    sm: CFTokens.SPACER.B,
    md: CFTokens.SPACER.C,
    lg: CFTokens.SPACER.D,
    xl: CFTokens.SPACER.D,
};
export const SEGMENT_CONTROL_SIZE = {
    xs: 24,
    sm: CFTokens.SIZE.D,
    md: CFTokens.SIZE.E,
    lg: CFTokens.SIZE.F,
    xl: CFTokens.SIZE.G,
};
export const SEGMENT_CONTROL_TYPE_SPEC = {
    xs: CFTokens.TYPE_SPEC_SCALE.D_BOLD_AUTO,
    sm: CFTokens.TYPE_SPEC_SCALE.E_BOLD_AUTO,
    md: CFTokens.TYPE_SPEC_SCALE.F_BOLD_AUTO,
    lg: CFTokens.TYPE_SPEC_SCALE.G_BOLD_AUTO,
    xl: CFTokens.TYPE_SPEC_SCALE.H_BOLD_AUTO,
};
